import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import { toast } from "react-toastify";
import {
  hasDeleteAccess,
  hasEditAccess,
} from "../../../../../../Common/CheckAccess";
import { DELETE_AMENITY_REQUEST, GET_AMENITY_REQUEST } from "../../../../../../Utils/Constant";
import { AmenityColumns } from "./AmenityData";

const AmenityTable = ({ setSelectedAmenity, listUpdated, permissions }) => {
  const dispatch = useDispatch();

  const { allAmenities,addAmenities, updateAmenities, deleteAmnities, loading, total } = useSelector((state) => state.amenity); // update selector if state shape is different
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    dispatch({
      type: GET_AMENITY_REQUEST,
      payload: {
        params: {
          page: currentPage,
          limit: pageSize,
        },
      },
    });
  }, [dispatch, currentPage, pageSize, listUpdated,addAmenities, updateAmenities, deleteAmnities]);

useEffect(() => {
  if (allAmenities) {
    const rawData = allAmenities?.data?.data || [];
    const pagination = allAmenities?.data?.pagination || {};

    const transformed = rawData.map((item, index) => ({
      id: (currentPage - 1) * pageSize + index + 1, 
      name: item.amenity_name,
      actions: (
        <>
          {/* {(hasDeleteAccess(permissions, "rooms") ||
            hasDeleteAccess(permissions, "front_desk")) && ( */}
            <button
              className="btn"
              onClick={() => {
                setShowDeleteDialog(true);
                setSelectedUser(item);
              }}
            >
              <i className="bi bi-trash text-danger"></i>
            </button>
          {/* )} */}
          <button
            className="btn"
            // disabled={
            //   !(
            //     hasEditAccess(permissions, "rooms") ||
            //     hasEditAccess(permissions, "front_desk")
            //   )
            // }
            data-bs-toggle="offcanvas"
            data-bs-target="#add-amenity"
            aria-controls="add-amenity"
            onClick={() => setSelectedAmenity(item)}
          >
            <i className="bi bi-pencil text-primary"></i>
          </button>
        </>
      ),
    }));

    setData(transformed);
    setTotalEntries(pagination.totalResults || 0); // Update total entries
  }
}, [allAmenities, permissions, total, currentPage, pageSize]);

  const confirmDelete = () => {
    dispatch({
      type: DELETE_AMENITY_REQUEST,
      payload: {
        id: selectedUser?.id,
        refresh: {
          page: currentPage,
          limit: pageSize,
        },
      },
    });

    setShowDeleteDialog(false)
  };

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <>
      <DataTable
        columns={AmenityColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={loading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />

      <ConfirmationATM
        show={showDeleteDialog}
        onClose={() => {
          setShowDeleteDialog(false);
          setSelectedUser(null);
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete amenity "${selectedUser?.amenity_name}"?`}
      />
    </>
  );
};

export default AmenityTable;
